/** @file Inspector panel registration (generated and hand-built forms). */
import type { PanelEntry } from '../panelEntry';
import { InspectorPanel } from './InspectorPanel';

/** Docked right of the viewport by default; no key bindings of its own. */
export const panel: PanelEntry = { id: 'inspector', title: 'panels.inspector.title', bindings: [], component: InspectorPanel };
